import React from 'react';
import { CheckIcon } from 'lucide-react';
import { curriculum, promise, takeaways } from '../data/masterclass';
export function Curriculum() {
  return <section aria-labelledby="curriculum-heading" className="border-b border-ink-line bg-ink-soft" data-id="element-26" data-mp="2edc4olokiq5s">
      <div className="mx-auto grid w-full max-w-7xl gap-14 px-6 py-20 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20 lg:px-10 lg:py-28" data-id="element-27" data-mp="25eqrz75s25cx">
        <div className="lg:sticky lg:top-16 lg:self-start" data-id="element-28" data-mp="2t42x9vxzht9y">
          <h2 id="curriculum-heading" className="font-display text-4xl font-bold uppercase leading-tight text-white sm:text-5xl" data-id="element-29" data-mp="2t6p4tvkvk8s6">
            Build the <span className="text-gold" data-id="element-30" data-mp="2je9mgx5o1i6r">us</span> first
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-white/65" data-id="element-31" data-mp="2ockwb7vynsoz">
            {promise}
          </p>

          <ul className="mt-10 space-y-3" data-id="element-32" data-mp="3c2fabss0nnat">
            {takeaways.map(item => <li key={item} className="flex items-start gap-3 text-white/75" data-id="element-33" data-mp="3guywvf8olsrr">
                <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-34" data-mp="1nh0762r5zwdk" />
                <span data-id="element-35" data-mp="1jhhkp2jp3d8m">{item}</span>
              </li>)}
          </ul>
        </div>

        <ol className="divide-y divide-ink-line border-y border-ink-line" data-id="element-36" data-mp="1x8w5nex5xoib">
          {curriculum.map((item, i) => <li key={item.title} className="grid grid-cols-[3rem_1fr] gap-4 py-7" data-id="element-37" data-mp="1sei9396rlbc2" data-mpi={i}>
              <span className="font-display text-2xl font-bold text-gold/60 tabular-nums" data-id="element-38" data-mp="273xyoluk7aq6">
                {String(i + 1).padStart(2, '0')}
              </span>
              <div data-id="element-39" data-mp="2g6fjqwyh9xbl">
                <h3 className="font-display text-2xl font-semibold uppercase text-white" data-id="element-40" data-mp="2g4w3h6ctnm9t">
                  {item.title}
                </h3>
                <p className="mt-2 leading-relaxed text-white/60" data-id="element-41" data-mp="2b59rf08qcc2l">{item.body}</p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}